<template>
    <v-container fluid>
        <v-row class="align-center pl-3">
            <!-- Breadcrumbs -->
            <v-breadcrumbs
                :items="[
                    { text: 'Home', disable: false, href: '/#/' },
                    { text: 'Plants', disabled: true }
                ]"
                divider="/"
            ></v-breadcrumbs>
            <v-spacer />
            <v-btn-toggle
                v-model="PlantFilterTab"
                class="mr-6"
                dense
                mandatory
                rounded
            >
                <v-btn small active-class="success--text"
                    >Active</v-btn>
                <v-btn small active-class="error--text"
                    >Archived</v-btn>
                <v-btn small
                    >All</v-btn>
            </v-btn-toggle>
        </v-row>

        <!-- New Plant Dialog-->
        <PlantEditDialog
            :dialog.sync="newPlantDialog"
            v-on:item-created="onPlantCreated"
        ></PlantEditDialog>

        <!-- plant Dialog -->
        <v-dialog v-model="plantDialog" scrollable>
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <v-btn icon dark @click="closePlantDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{
                        selectedPlantNode ? selectedPlantNode.name : "Plant"
                    }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        dark
                        @click="goToPlantDetail(selectedPlantNodeId)"
                    >
                        <v-icon>launch</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mx-0 px-0">
                    <PlantDetailComponent
                        v-if="selectedPlantNodeId"
                        :plantNodeId="selectedPlantNodeId"
                        v-on:plant-items-updated="refreshCurrentPage"
                        v-on:item-deleted="onPlantDeleted"
                    ></PlantDetailComponent>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- Delete Dialog -->
        <!-- <DeleteDialog
            :dialog.sync="deleteDialog"
            :item="deletedPlant"
            v-on:confirmed="deletingConfirmed"
        >
            <template v-slot:title>Delete - {{ deletedPlant ? deletedPlant.node.name : "" }}</template>
            <template v-slot:content>Are you sure you want to delete this plant?</template>
        </DeleteDialog>-->

        <v-row class="ma-0">
            <v-col cols="12" class="pt-0">
                <v-hover>
                    <template v-slot="{ hover }">
                        <v-card :elevation="hover ? 6 : 1">
                            <v-card-title class="pb-0">
                                <v-icon color="primary" class="mx-2">eco</v-icon
                                >Plants
                                <v-btn
                                    v-if="hasPermission('view_plant')"
                                    icon
                                    fab
                                    small
                                    class="mr-5"
                                    @click="goToPlantSettings()"
                                >
                                    <v-icon>settings</v-icon>
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-col cols="12" sm="4">
                                    <v-row justify="end" align="end">
                                        <v-text-field
                                            dense
                                            v-model="search"
                                            append-outer-icon="refresh"
                                            @click:append-outer="
                                                refreshCurrentPage()
                                            "
                                            label="Search"
                                            clearable
                                            hide-details
                                            class="mx-2"
                                            @keydown.enter="
                                                refreshCurrentPage()
                                            "
                                            @click:clear="onClearSearch()"
                                        ></v-text-field>
                                    </v-row>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-btn
                                    v-if="hasPermission('add_plant')"
                                    color="primary"
                                    dark
                                    outlined
                                    rounded
                                    small
                                    class="mx-2"
                                    @click="newPlantDialog = true"
                                    >New Plant</v-btn
                                >
                                <!-- <v-speed-dial
                                            direction="left"
                                            transition="slide-x-reverse-transition"
                                        >
                                            <template v-slot:activator>
                                                <v-btn small text fab>
                                                    <v-icon>more_vert</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-btn
                                                color="primary"
                                                dark
                                                fab
                                                x-small
                                                @click="newPlantDialog=true"
                                            >
                                                <v-icon>add</v-icon>
                                            </v-btn>
                                </v-speed-dial>-->
                            </v-card-title>

                            <v-container fluid>
                                <v-data-table
                                    :headers="headers"
                                    :loading="
                                        $apollo.queries.tenantPlants.loading
                                    "
                                    :items="tenantPlants.edges"
                                    :options.sync="dataTableOptions"
                                    loading-text="Loading... Please wait"
                                    :server-items-length="
                                        tenantPlants.totalCount
                                    "
                                    :items-per-page="defaultItemsPerPage"
                                    :footer-props="{
                                        'items-per-page-options': [
                                            10,
                                            25,
                                            50,
                                            75,
                                            100
                                        ],
                                        'disable-pagination':
                                            $apollo.queries.tenantPlants.loading
                                    }"
                                >
                                    <template
                                        v-slot:item.node.numTemplates="{ item }"
                                    >
                                        <span
                                            v-if="item.node.numTemplates == 0"
                                            class="error--text"
                                            >{{ item.node.numTemplates }}</span
                                        >
                                        <span v-else>{{
                                            item.node.numTemplates
                                        }}</span>
                                    </template>
                                    <template
                                        v-slot:item.node.numProducts="{ item }"
                                    >
                                        <span
                                            v-if="item.node.numProducts == 0"
                                            class="error--text"
                                            >{{ item.node.numProducts }}</span
                                        >
                                        <span v-else>{{
                                            item.node.numProducts
                                        }}</span>
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <!-- <v-btn
                                            outlined
                                            rounded
                                            small
                                            color="primary"
                                            @click="openPlantDialog(item.node)"
                                        >View</v-btn>-->
                                        <v-toolbar flat color="transparent">
                                        <v-btn
                                            icon
                                            color="primary"
                                            @click="openPlantDialog(item.node)"
                                        >
                                            <v-icon>remove_red_eye</v-icon>
                                        </v-btn>
                                        <v-btn
                                            icon
                                            color="primary"
                                            @click="
                                                goToPlantDetail(item.node.id)
                                            "
                                        >
                                            <v-icon>launch</v-icon>
                                        </v-btn>
                                        <v-tooltip
                                                top
                                                v-if="item.node.isArchived"
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs
                                                    }"
                                                >
                                                    <v-btn
                                                        icon
                                                        color="primary"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click="
                                                            archivePlant(
                                                                item.node.id,
                                                                false
                                                            )
                                                        "
                                                    >
                                                        <v-icon
                                                            >settings_backup_restore</v-icon
                                                        >
                                                    </v-btn>
                                                </template>
                                                <span>Restore</span>
                                            </v-tooltip>
                                            <v-tooltip
                                                top
                                                v-if="!item.node.isArchived"
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs
                                                    }"
                                                >
                                                    <v-btn
                                                        icon
                                                        color="primary"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click="
                                                            archivePlant(
                                                                item.node.id,
                                                                true
                                                            )
                                                        "
                                                    >
                                                        <v-icon
                                                            >inventory_2</v-icon
                                                        >
                                                    </v-btn>
                                                </template>
                                                <span>Archive</span>
                                            </v-tooltip>
                                        </v-toolbar>
                                        <!-- <v-icon small @click="deletingPlant(item)">delete</v-icon> -->
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-card>
                    </template>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import PlantEditDialog from "@/components/plants/PlantEditDialog.vue";
import PlantDetailComponent from "@/components/plants/PlantDetailComponent.vue";
// import DeleteDialog from "@/components/base/DeleteDialog.vue";

export default {
    name: "plant-list-page",
    components: {
        PlantEditDialog,
        PlantDetailComponent
        // DeleteDialog
    },

    apollo: {
        tenantPlants: {
            query: gql`
                query tenantPlants(
                    $first: Int
                    $last: Int
                    $before: String
                    $after: String
                    $orderBy: String
                    $search: String #this variable name must by $search
                    $isArchived: Boolean
                ) {
                    tenantPlants(
                        first: $first
                        last: $last
                        before: $before
                        after: $after
                        search: $search
                        isArchived: $isArchived
                        orderBy: $orderBy
                    ) {
                        edgeCount
                        totalCount
                        pageInfo {
                            startCursor
                            endCursor
                            hasPreviousPage
                            hasNextPage
                        }
                        edges {
                            node {
                                id
                                name
                                numColors
                                numPotsizes
                                numEnvironments
                                numTags
                                numTemplates
                                numProducts
                                isArchived
                                plantSpecies {
                                    id
                                    name
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    first: 10
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.tenantPlants,
            skip: true,
            pollInterval: 60000 // ms

            // pollInterval: 300 // ms
        }
    },

    data: function() {
        return {
            // isLoadingPlantsTable: false,
            newPlantDialog: false,
            plantDialog: false,
            deleteDialog: false,
            deletedPlant: null,
            search: "",

            selectedPlantNodeId: null,
            selectedPlantNode: null,

            defaultItemsPerPage: 25,
            dataTableOptions: {},
            page: 1,

            PlantFilterTab: 0,
            tenantPlants: {},

            headers: [
                {
                    text: "Plant Species",
                    value: "node.plantSpecies.name",
                    sortable: true
                },
                {
                    text: "Name",
                    align: "left",
                    value: "node.name",
                    sortable: true
                },
                {
                    text: "#Pot Sizes",
                    value: "node.numPotsizes",
                    sortable: true
                },
                {
                    text: "#Colors",
                    value: "node.numColors",
                    sortable: true
                },
                {
                    text: "#Environments",
                    value: "node.numEnvironments",
                    sortable: true
                },
                {
                    text: "#Tags",
                    value: "node.numTags",
                    sortable: true
                },
                {
                    text: "#Templates",
                    value: "node.numTemplates",
                    sortable: true
                },
                {
                    text: "#Products",
                    value: "node.numProducts",
                    sortable: true
                },
                {
                    text: "Actions",
                    value: "action",
                    width: "120px",
                    align: "center",
                    sortable: false
                }
            ],
            editedIndex: -1
        };
    },
    computed: {
        // plants: function() {
        //     return this.$store.state.plants.plants;
        // },
        // editedPlant: function() {
        //     if (this.editedIndex > -1) {
        //         return this.plants[this.editedIndex];
        //     } else {
        //         return null;
        //     }
        // },
        isArchived() {
            return this.PlantFilterTab == 1
                ? true
                : this.PlantFilterTab == 0
                ? false
                : null;
        },
    },
    watch: {
        // page(newValue, oldValue) {
        //     if (newValue > oldValue) {
        //         this.getNextPage();
        //     } else {
        //         this.getPrevPage();
        //     }
        // },
        // itemsPerPage() {
        //     this.refreshCurrentPage();
        // }
        dataTableOptions: {
            handler() {
                this.refreshCurrentPage();
            },
            deep: true
        },
        PlantFilterTab(value) {
            if (value != null) {
                localStorage.setItem("PlantFilterTab", value);

                this.refreshCurrentPage();
            }
        }
    },
    created() {
        // this.initialize();
        this.hasPermission = helper.hasPermission;
    },
    methods: {
        // initialize() {
        //     // this.fetchPlants();
        // },

        // fetchPlants() {
        //     // fetch plants
        //     this.isLoadingPlantsTable = true;
        //     this.$store
        //         .dispatch("plants/fetchPlants")
        //         .then(() => {
        //             // console.log("Fetched plants");
        //             // this.snackbarText = `${this.plants.length} plants fetched!`;
        //             // this.snackbar = true;
        //         })
        //         .catch(error => {
        //             /*handle errors*/
        //             console.log(error);
        //         })
        //         .finally(() => (this.isLoadingPlantsTable = false));
        // },

        onClearSearch() {
            this.search = "";

            this.refreshCurrentPage();
        },

        refreshCurrentPage() {
            const {
                sortBy,
                sortDesc,
                page,
                itemsPerPage
            } = this.dataTableOptions;

            // console.log(this.dataTableOptions);

            var _first = itemsPerPage;
            var _last = null;
            var _before = null;
            var _after = null;
            var _orderBy = null;

            if (page < this.page) {
                _first = null;
                _last = itemsPerPage;
                _before = this.tenantPlants.pageInfo.startCursor;
                _after = null;
            }

            if (page > this.page) {
                _first = itemsPerPage;
                _last = null;
                _before = null;
                _after = this.tenantPlants.pageInfo.endCursor;
            }

            switch (sortBy[0]) {
                case "node.plantSpecies.name":
                    _orderBy = "plantSpeciesName";
                    break;
                case "node.name":
                    _orderBy = "plantName";
                    break;
                case "node.numColors":
                    _orderBy = "numColors";
                    break;
                case "node.numPotsizes":
                    _orderBy = "numPotsizes";
                    break;
                case "node.numEnvironments":
                    _orderBy = "numEnvironments";
                    break;
                case "node.numTags":
                    _orderBy = "numTags";
                    break;
                case "node.numTemplates":
                    _orderBy = "numTemplates";
                    break;
                case "node.numProducts":
                    _orderBy = "numProducts";
                    break;
                default:
                    _orderBy = null;
                    break;
            }

            if (sortDesc[0] === true) {
                _orderBy = "-" + _orderBy;
            }

            this.$apollo.queries.tenantPlants.setVariables({
                first: _first,
                last: _last,
                before: _before,
                after: _after,
                orderBy: _orderBy,
                search: this.search,
                isArchived: this.isArchived,
            });

            // set skip false to execute the query
            this.$apollo.queries.tenantPlants.skip = false;
            this.$apollo.queries.tenantPlants.refresh();

            // update this.page
            this.page = page;
        },

        // getPrevPage() {
        //     this.$apollo.queries.tenantPlants.setVariables({
        //         first: null,
        //         last: this.itemsPerPage,
        //         before: this.tenantPlants.pageInfo.startCursor,
        //         after: null,
        //         search: this.search
        //     });
        // },

        // getNextPage() {
        //     this.$apollo.queries.tenantPlants.setVariables({
        //         first: this.itemsPerPage,
        //         last: null,
        //         before: null,
        //         after: this.tenantPlants.pageInfo.endCursor,
        //         search: this.search
        //     });
        // },

        openPlantDialog(plant) {
            this.selectedPlantNodeId = plant.id;
            this.selectedPlantNode = plant;
            this.plantDialog = true;
            // this.$router.push({
            //     name: "plant-detail",
            //     params: { id: plant.id }
            // });
        },

        closePlantDialog() {
            this.plantDialog = false;
            this.selectedPlantNodeId = null;
            this.selectedPlantNode = null;
            this.$apollo.queries.tenantPlants.refresh();
            // this.refreshCurrentPage();
        },

        onPlantCreated(response) {
            this.refreshCurrentPage();

            this.goToPlantDetail(response.id);
        },

        onPlantDeleted() {
            // this.refreshCurrentPage();
            this.closePlantDialog();
        },

        goToPlantDetail(plantNodeId) {
            // this.$router.push({
            //     name: "plant-detail",
            //     params: { id: plant.id }
            // });

            let routeData = this.$router.resolve({
                name: "plant-detail",
                params: { id: plantNodeId }
            });
            window.open(routeData.href, "_blank");
        },

        goToPlantSettings() {
            this.$router.push({
                name: "plant-settings"
            });
        },

        archivePlant(PlantNodeId, isArchived) {
            this.$apollo
                .mutate({
                    // Query
                    mutation: gql`
                        mutation archivePlant($input: ArchivePlantInput!) {
                            archivePlant(input: $input) {
                                plant {
                                    id
                                    isArchived
                                }
                            }
                        }
                    `,
                    // Parameters
                    variables: {
                        input: {
                            id: PlantNodeId,
                            isArchived: isArchived
                        }
                    }
                })
                .then(() => {
                    // this.isLoadingPlannedTaskPhases = false;
                    // console.log(response);

                    // show snackbar
                    const payload = {
                        color: "success",
                        message: `Updated!`
                    };
                    this.$store.dispatch("snackbar/showMessage", payload);

                    this.refreshCurrentPage();
                })
                .catch(error => {
                    // this.isLoadingPlannedTaskPhases = false;

                    // Error
                    console.error(error);

                    // show snackbar
                    const payload = {
                        color: "error",
                        message: `Failed!`
                    };
                    this.$store.dispatch("snackbar/showMessage", payload);
                })
                .finally(() => {
                    // this.loadingOperatingCostsKey = false;
                });
        }

        // deletingPlant(item) {
        //     this.deletedPlant = item;
        //     this.deleteDialog = true;
        // },

        // deletingConfirmed(item) {
        //     if (item) {
        //         const payload = {
        //             id: item.node.id
        //         };
        //         this.$store
        //             .dispatch("plants/deletePlant", payload)
        //             .then(response => {
        //                 // refresh plants
        //                 this.fetchPlants();

        //                 // close delete dialog
        //                 this.deleteDialog = false;

        //                 // show snackbar
        //                 const payload = {
        //                     color: "success",
        //                     message: `${response.name} is deleted!`
        //                 };
        //                 this.$store.dispatch("snackbar/showMessage", payload);
        //             })
        //             .catch(error => {
        //                 this.error = error.graphQLErrors[0].message;
        //             });
        //     }
        // }
    }
};
</script>